import { render, staticRenderFns } from "./CountrySupportAssignment.vue?vue&type=template&id=4c2ab660&scoped=true"
import script from "./CountrySupportAssignment.vue?vue&type=script&lang=js"
export * from "./CountrySupportAssignment.vue?vue&type=script&lang=js"
import style0 from "./CountrySupportAssignment.vue?vue&type=style&index=0&id=4c2ab660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ab660",
  null
  
)

export default component.exports